import PopupApi from '@/api/popup';
import { PopupIdEnum, PopupRelatedStatusEnum } from '@/api/popup/types';
import { ubtSendError } from '@/shared/utils/ubt';

const backPopRelatedStatus: Partial<Record<PopupIdEnum, PopupRelatedStatusEnum>> = {
  [PopupIdEnum.VERIFY_CREDIT_IDENTITY_BACK]: PopupRelatedStatusEnum.INIT,
};

/** 判断是否需要展示-身份证回退挽留弹窗 */
export const checkShowIdentityBackPopup = async (): Promise<boolean> => {
  const popupId = PopupIdEnum.VERIFY_CREDIT_IDENTITY_BACK;

  if (backPopRelatedStatus[popupId] === PopupRelatedStatusEnum.CHECKING_SHOW) {
    throw new Error('checkShowIdentityBackPopup--checking');
  }

  try {
    backPopRelatedStatus[popupId] = PopupRelatedStatusEnum.CHECKING_SHOW;

    const popupControl = await PopupApi.queryPopupFatigue(popupId);
    return popupControl?.canShow;
  } catch (error) {
    ubtSendError({
      name: 'checkShowIdentityBackPopup-error',
      message: (error as Error).message,
    });
    return false;
  } finally {
    backPopRelatedStatus[popupId] = PopupRelatedStatusEnum.INIT;
  }
};
